var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('keep-alive',{attrs:{"max":1,"include":_vm.keepAlive}},[_c('router-view')],1)],1),_vm._v(" "),(_vm.weChatBool)?_c('weChat',{on:{"colseWeChat":function($event){_vm.weChatBool=false}}}):_vm._e(),_vm._v(" "),(!_vm.footBool)?_c('temFoot'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c829e30e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 